import { env } from 'src/config/env'

/** The list of features, add new features to this list. */
export enum FeatureList {
  /** We can force invite users on the enterprise directory. */
  ENTERPRISE_DIRECTORY_FORCE_INVITE = 'enterprise_directory_force_invite',
  /** New consumer portal. V2. */
  CONSUMER_PORTAL_V2 = 'consumer_portal_v2',
  /** Mobile version enterprise dashboard. */
  ENTERPRISE_DASHBOARD_MOBILE = 'enterprise_dashboard_mobile',
}

export interface FeatureFlagConfig {
  // The name of the feature
  name: FeatureList
  // The environments in which the feature is enabled
  enabled: ('local' | 'dev' | 'prod' | 'staging' | 'test')[]
}

export const featureFlag: Record<FeatureList, FeatureFlagConfig> = {
  [FeatureList.ENTERPRISE_DIRECTORY_FORCE_INVITE]: {
    name: FeatureList.ENTERPRISE_DIRECTORY_FORCE_INVITE,
    enabled: ['local'],
  },
  [FeatureList.CONSUMER_PORTAL_V2]: {
    name: FeatureList.CONSUMER_PORTAL_V2,
    enabled: ['dev', 'local'],
  },
  [FeatureList.ENTERPRISE_DASHBOARD_MOBILE]: {
    name: FeatureList.ENTERPRISE_DASHBOARD_MOBILE,
    enabled: ['local'],
  },
}

/** Hook to check if a feature is enabled in the current environment. */
export const useFeatureFlag = (feature: FeatureList) => {
  const featureEnabled = featureFlag[feature].enabled
  if (featureEnabled.includes(env.MODE)) {
    return true
  }
  return false
}
